/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ListRequestModel } from 'app/api/models/list-request.model';
import { Observable } from 'rxjs';
import { ApiResponseSummary } from '../models/api-info.model';

// interface to be implemented by ListServiceBase which is the base class for all services injected into componets using the AddList component
// the interface is used by the AddListComponent which is used as a base component for all Add List components
// export interface IAddListService {
//   itemsCount: number;
//   ListRequest: ListRequestModel;
//   itemDeleted$: Observable<number>;
//   listReloaded$: Observable<number>;
//   resetListRequest();
//   reload(); // reload the contents of the list
//   saveState(); // reload the contents of the list
//   loadState(); // reload the contents of the list
//   addNew(item: any): void; // add a new item
//   setSort(column: string, direction: string);
//   setPaging(pageSize: number, pageNumber: number);
//   deleteItem(itemId: number, title?: string, message?: string): Promise<void>;
//   updateItem(itemId: number, dataToUpdate: any): Promise<ApiResponseSummary<any>>;
//   getEditableItemDetail(itemId: number): Promise<ApiEntity>;
//   exportToExcel();
// }

export abstract class IAddListService {
  constructor(
    public itemsCount: number,
    public ListRequest: ListRequestModel,
    public itemDeleted$: Observable<number>,
    public listReloaded$: Observable<number>
  ) {}

  abstract get itemList(): any[];
  abstract reload(): any; // reload the contents of the list
  abstract addNew(item: any): void; // add a new item
  abstract setSort(column: string, direction: string): any;
  abstract deleteItem(itemId: number, title?: string, message?: string): Promise<void>;
  abstract updateItem(itemId: number, dataToUpdate: any): Promise<ApiResponseSummary<any>>;
  abstract getEditableItemDetail(itemId: number): Promise<ApiEntity>;
  abstract setPaging(pageSize, pageNumber);
  abstract exportToExcel();
}
